/**
 * Declares Next.js Revalidation times in seconds
 */
export enum CACHE_TIME {
  NO_CACHE = 0,
  ONE_MINUTE = 60,
  FIVE_MINUTES = 300,
  TEN_MINUTES = 600,
  THIRTY_MINUTES = 1800,
  ONE_HOUR = 3600,
  ONE_DAY = 86400,
  ONE_WEEK = 604800
}
